export default __webpack_public_path__ + "static/media/error.734879a2.jpg";